import { defineComponent, h } from 'vue';
//import Vuetify from "vuetify";
import EventBus from "./event-bus.js";
import axios from "axios";
import ace from "./components/3rdParty/AceEditor.jsx";
import utils from "../Shared/utils.jsx";
import methods from "../Shared/methods.js";
import filters from "../Shared/filters.js";
import computed from "../Shared/computed.js";
import careHelpfulFunctions from "./careHelpfulFunctions.jsx";
import { installCareTestProbe } from "../Shared/careTestProbe.js";
import { installCareAgentProbe } from "../Shared/careAgentProbe.js";
import BaseComponent from "./components/BaseComponentMixin.jsx";
import token from "@/Services/token";
import api from "@/Services/api";
import theme from "@/plugins/theme";

installCareTestProbe();
installCareAgentProbe();

/*
 *  ATTN: To access a Vue 3 component at runtime from the browser without relying upon the Vue 3 dev tools browser, use the following syntax
 *  after selecting the item within the DOM view:
 *      $0.__vueParentComponent.proxy
 *  
 *  Compare to the Vue 2 syntax:
 *      $0.__vue__
 *
 * */

//import VueApexCharts from 'vue-apexcharts'
//Vue.use(VueApexCharts);
//Vue.component('apexchart', VueApexCharts);

//// Import all CallCorp controls which will register them with Vue
import Accordion from "./components/Accordion.jsx";
import ACDDirectButton from "./components/ACDDirectButton.jsx";
import AdvancedHistory from "./components/AdvancedHistory.vue";
//Vue.component("advanced-history", AdvancedHistory);
import AdvancedReports from "./components/AdvancedReports.vue";
//Vue.component("advanced-reports", AdvancedReports);
//import AgGrid from "./components/AgGrid.jsx";
import ApexGeneralChart from "./components/ApexGeneralChart.vue";
import AppleButton from "./components/AppleButton.jsx";
import APITester from "./components/APITester.jsx";
import AudioPlayer from "./components/AudioPlayer.vue";
//Vue.component("audio-player", AudioPlayer);
import AutoComplete from "./components/AutoComplete.jsx";
import Avatar from "./components/Avatar.jsx";
import BadgeHandler from './components/BadgeHandler.jsx';
import BarChart from "./components/BarChart.jsx";
import BasicButton from "./components/BasicButton.jsx";
import BasicFileUpload from "./components/BasicFileUpload.vue";
import CallCenterHome from "./components/CallCenterHome.vue";
import BasicForm from "./components/BasicForm.jsx";
import BasicGrid from "./components/BasicGrid.jsx";
import BasicInput from "./components/BasicInput";
import BasicLink from "./components/BasicLink.jsx";
import BasicTab from "./components/BasicTab.jsx";
import BasicToggle from "./components/BasicToggle.jsx";
import BasicTree from "./components/BasicTree.jsx";
import Checkbox from "./components/Checkbox.jsx";
import BasicPopupMenu from "./components/BasicPopupMenu.jsx";
import BroadcastListener from "./components/BroadcastListener.jsx";
import "./components/CallcorpPlayer";
import CalendarPicker from "./components/CalendarPicker.jsx";
import CalendarRangePicker from "./components/CalendarRangePicker.jsx";
import CardList from "./components/CardList.jsx";
//import CardBrowser from "./components/CardBrowser.jsx";
//import CheetahGrid from "./components/CheetahGrid.jsx";
import CircleChart from "./components/CircleChart.jsx";
import ComboBox from "./components/ComboBox.jsx";
//import ControlContainer from "./components/ControlContainer.jsx";
import ControlDesigner from "./components/ControlDesigner.jsx";
import ControlDesignerV3 from "./components/ControlDesigner_v3.jsx";
import ConversationView from "./components/ConversationView.jsx";
import CssStyle from "./components/CssStyle.jsx";
import Dash from "./components/Dash.jsx";
//import DateRangePicker from "./components/DateRangePicker.jsx";
//import DefaultUnknown from "./components/DefaultUnknown.jsx";
import DebugHsmLog from "./components/DebugHsmLog.vue";
import DesktopNotify from "./components/DesktopNotify.jsx";
import DockLayout from './components/DockLayout.jsx';
import DocumentBootstrap from "./components/DocumentBootstrap.jsx";
import DropdownFileList from "./components/DropdownFileList.vue";
import DropdownList from "./components/DropdownList.jsx";
import DropdownMultiSelect from "./components/DropdownMultiSelect.jsx";
import DynamicControlContainer from "./components/DynamicControlContainer.jsx";
import DynamicMenuList from "./components/DynamicMenuList.jsx";
import DynamicTab from "./components/DynamicTab.jsx";
import DynamicTabContent from "./components/DynamicTabContent.jsx";
import DynamicTree from "./components/DynamicTree.jsx";
import FastGrid from "./components/FastGrid.jsx";
import FileDiffv2 from "./components/FileDiffv2.vue";
import FlowV2 from "./components/vuecontrols/flowv2/FlowV2_v1.jsx";
//import FlowV2 from "./components/vuecontrols/flowv2/main.vue";
import FlowChart from "./components/FlowChart.jsx";
import ForEach from "./components/ForEach.jsx";
//import ForEachSimple from "./components/ForEachSimple.jsx";
////import Hsm from './components/HSM.jsx';
//import GoogleButton from "./components/GoogleButton.jsx";
import GoogleButton_v2 from "./components/GoogleButton_v2.jsx";
import HsmNew from "./components/HSM/HSM.jsx";
import HSMContainer from './components/HSM/HSMContainer.jsx';
import HSMState from './components/HSM/HSMState.jsx';
import UserControlHSM from './components/HSM/UserControlHSM.jsx';
//import HorizontalStack from "./components/HorizontalStack.jsx";
//import HtmlEditor from "./components/HtmlEditor.jsx";
import HtmlTable from "./components/HtmlTable.jsx";
import Html from "./components/Html.jsx";
import Icon from "./components/Icon.jsx";
import IconPopupMenu from "./components/IconPopupMenu.jsx";
import IconStack from "./components/IconStack.jsx";
//import IdleTimeout from "./components/IdleTimeout.jsx";
import IFrame from "./components/IFrame.jsx";
import SandboxedApp from "./components/SandboxedApp.jsx";
import NativeVueHost from "./components/NativeVueHost.vue";
import { registerNativePages } from "./pages/registerNativePages.js";
import Image from "./components/Image.jsx";
import InfiniteConversationView from "./components/InfiniteConversationView.jsx";
import InfiniteGrid from "./components/InfiniteGrid.jsx";
import Interval from "./components/Interval.jsx";
import Javascript from "./components/Javascript.jsx";
import LineChart from "./components/LineChart.vue";
//Vue.component("line-chart", LineChart);
import MediaApproval from "./components/MediaApproval.vue";
//import MenuFlowChart from "./components/MenuFlowChart.jsx";
//Vue.component("media-approval", MediaApproval);
import MultiSelectList from "./components/MultiSelectList.vue";
//Vue.component("multiselectlist", MultiSelectList);
//import MultiSelectListItem from "./components/MultiSelectListItem.vue";
//Vue.component("multiselectlistitem", MultiSelectListItem);
import NavigationDrawer from "./components/NavigationDrawer.jsx";
import Notification from "./components/Notification.jsx";
import PopupMenuButton from "./components/PopupMenuButton.jsx";
import ProgressBar from "./components/ProgressBar.jsx";
import ProgressCircle from "./components/ProgressCircle.jsx";
//import RealTimeGrid from "./components/RealTimeGrid.jsx";
import RealTimeGridAg from "./components/RealTimeGridAg.jsx";
import RealTimeWidgetListener from "./components/RealTimeWidgetListener.jsx";
//import ReCaptcha from "./components/ReCaptcha.jsx";
import RoosterEditor from "./components/RoosterEditor.vue";
import RTEventHandler from "./components/RTEventHandler.jsx";
import SAMLButton from "./components/SAMLButton.jsx";
import Search from "./components/Search.jsx";
import SearchQueryBuilder from "./components/SearchQueryBuilder.vue";
import SelectList from "./components/SelectList.jsx";
import ServerEventListener from "./components/ServerEventListener.jsx";
//import SlimGrid from "./components/SlimGrid.jsx";
import SoftPhone from "./components/SoftPhone.vue";
//Vue.component("soft-phone", SoftPhone);
import SoundPlayer from "./components/SoundPlayer.jsx";
//import SplitButton from "./components/SplitButton.jsx";
import SplitPanes from "./components/SplitPanes.jsx";
import Text from "./components/Text.jsx";
import Markdown from "./components/Markdown.jsx";
import TextEditor from "./components/TextEditor.jsx";
import Timeline from "./components/Timeline.jsx";
import Timeout from "./components/Timeout.jsx";
import TranslationContainer from './components/TranslationContainer.jsx';
import TreeView from "./components/TreeView.jsx";
import TreeViewDsgn from './components/designer/TreeView.jsx';
import UserActionListener from "./components/UserActionListener.jsx";
import UserControl from "./components/UserControl.jsx";
import VerticalStack from "./components/VerticalStack.jsx";
import Watcher from "./components/Watcher.jsx";
import WebRtcPhone from "./components/WebRtcPhone.jsx";
import Wizard from './components/Wizard.jsx';
import WizardButton from './components/WizardButton.jsx';
import YouTubeVideo from "./components/YouTubeVideo.jsx";

//import ExperimentalTab from "./components/ExperimentalTab.jsx";
//import HiddenContainer from "./components/HiddenContainer.jsx";

//import dayjs from "dayjs";

//import RappidPlugin from './components/3rdParty/rappid';
//import vuetify from '@/plugins/vuetify';

//Vue.use(RappidPlugin);

import Dummy from './components/dummy.jsx';

// Schema form components
import formFieldset from './components/schemaform/formFieldset.jsx';
import formArray from './components/schemaform/formArray.jsx';
import formAnyOf from './components/schemaform/formAnyOf.jsx';
import formTabArray from './components/schemaform/formTabArray.jsx';
import formText from './components/schemaform/formText.jsx';
import formPassword from './components/schemaform/formPassword.jsx';
import formTextarea from './components/schemaform/formTextarea.jsx';
import formCheckbox from './components/schemaform/formCheckbox.jsx';
import formCheckboxes from './components/schemaform/formCheckboxes.jsx';
import formSwitch from './components/schemaform/formSwitch.jsx';
import formRadios from './components/schemaform/formRadios.jsx';
import formHelp from './components/schemaform/formHelp.jsx';
import formParagraph from './components/schemaform/formParagraph.jsx';
import formNumber from './components/schemaform/formNumber.jsx';
import formMediaSelector from './components/schemaform/formMediaSelector.jsx';
import formInputWithHeaderBar from './components/schemaform/formInputWithHeaderBar.jsx';
import formTextareaWithHeaderBar from './components/schemaform/formTextareaWithHeaderBar.jsx';
import formLookupList from './components/schemaform/formLookupList.jsx';
import formSection from './components/schemaform/formSection.jsx';
import formLocaleSection from './components/schemaform/formLocaleSection.jsx';
import formSelect from './components/schemaform/formSelect.jsx';
import formDropdownMultiSelect from './components/schemaform/formDropdownMultiSelect.jsx';
import formTTSVoicePicker from './components/schemaform/formTTSVoicePicker.jsx';
import formPhoneNumber from './components/schemaform/formPhoneNumber.jsx';
import formDateTime from './components/schemaform/formDateTime.jsx';
import formDate from './components/schemaform/formDate.jsx';
import formTime from './components/schemaform/formTime.jsx';
import formDatePicker from './components/schemaform/formDatePicker.jsx';
import formDateRangePicker from './components/schemaform/formDateRangePicker.jsx';
import formSingleDatePicker from './components/schemaform/formSingleDatePicker.jsx';
import formEmail from './components/schemaform/formEmail.jsx';
import formTabs from './components/schemaform/formTabs.jsx';
import formConditional from './components/schemaform/formConditional.jsx';
import formControlsWithLabel from './components/schemaform/formControlsWithLabel.jsx';
import formBasicIconPicker from './components/schemaform/formBasicIconPicker.jsx';
import formActions from './components/schemaform/formActions.jsx';
import formButton from './components/schemaform/formButton.jsx';
import formIconPicker from './components/schemaform/formIconPicker.jsx';
import formTags from './components/schemaform/formTags.jsx';
import formTextEditor from './components/schemaform/formTextEditor.jsx';
import formHtmlEditor from './components/schemaform/formHtmlEditor.jsx';
import formMarkdownEditor from './components/schemaform/formMarkdownEditor.jsx';
import formReferencedDocumentSchema from './components/schemaform/formReferencedDocumentSchema.jsx';
import formFilePicker from './components/schemaform/formFilePicker.vue';
import formFilePickerWithHeaderBar from './components/schemaform/formFilePickerWithHeaderBar.jsx';
import tableLayout from './components/schemaform/layoutTable.jsx';
import layoutCard from './components/schemaform/layoutCard.jsx';

// Property Grid components
import formInput from './components/form/input.jsx';
//import formInputMulti from './components/form/inputmultiline.jsx';
import formTextEditorPropGrid from './components/form/texteditor.jsx';
import formNumberPropGrid from './components/form/number.jsx';
//import formCheckbox from './components/form/checkbox.jsx';
import formBoolean from './components/form/boolean.jsx';
import formSelectPropGrid from './components/form/select.jsx';
import formAnyOfPropGrid from './components/form/anyof.jsx';
import formArrayPropGrid from './components/form/array.jsx';
import nullableType from './components/form/nullabletype.jsx';
////import schemaProperties from './SchemaProperties.jsx';
import ReferencedDocumentSchema from './components/form/referencedDocumentSchema.jsx';
import HsmStatementSchema from './components/form/hsmStatementSchema.jsx';
import LookupList from './components/form/lookupList.jsx';

// Form designer versions of components
import AccordionDsgn from './components/designer/Accordion.jsx';
import ApexGeneralChartDsgn from './components/designer/ApexGeneralChart.jsx';
import AudioPlayerDsgn from './components/designer/AudioPlayer.jsx';
import AvatarDsgn from './components/designer/Avatar.jsx';
import BasicButtonDsgn from './components/designer/BasicButton.jsx';
import BasicGridDsgn from './components/designer/BasicGrid.jsx';
import BasicInputDsgn from './components/designer/BasicInput.jsx';
import BroadcastListenerDsgn from './components/designer/BroadcastListener.jsx';
//import BackgroundSvc from './designer/BackgroundService.jsx';
import BasicFormDsgn from './components/designer/BasicForm.jsx';
import BasicLinkDsgn from './components/designer/BasicLink.jsx';
import BasicPopupMenuDsgn from './components/designer/BasicPopupMenu.jsx';
import BasicToggleDsgn from './components/designer/BasicToggle.jsx';
import BasicTabDsgn from './components/designer/BasicTab.jsx';
import BasicTreeDsgn from './components/designer/BasicTree.jsx';
import BackgroundServiceDsgn from './components/designer/BackgroundService.jsx';
import BasicIconDsgn from './components/designer/Icon.jsx';
import CalendarPickerDsgn from './components/designer/CalendarPicker.jsx';
import CardListDsgn from './components/designer/CardList.jsx';
import CareCenterMenuDsgn from './components/designer/CareCenterMenu.jsx';
import CareCenterPopupMenuDsgn from './components/designer/CareCenterPopupMenu.jsx';
import CheckboxDsgn from './components/designer/Checkbox.jsx';
import ComboBoxDsgn from './components/designer/ComboBox.jsx';
import DashDsgn from './components/designer/Dash.jsx';
//import ControlContainerDsgn from './designer/ControlContainer.jsx';
//import ControlDesignerDsgn from './designer/ControlDesigner.jsx';
import DefaultUnknownDsgn from "./components/designer/DefaultUnknown.jsx";
import DisplayBasicModal from './components/designer/actions/DisplayBasicModal.jsx';
import DocumentBootstrapDsgn from './components/designer/DocumentBootstrap.jsx';
import DropdownListDsgn from './components/designer/DropdownList.jsx';
import DropdownMultiSelectDsgn from './components/designer/DropdownMultiSelect.jsx';
import DynamicControlContainerDsgn from './components/designer/DynamicControlContainer.jsx';
import DynamicMenuListDsgn from './components/designer/DynamicMenuList.jsx';
import DynamicTabDsgn from './components/designer/DynamicTab.jsx';
import DynamicTabContentDsgn from './components/designer/DynamicTabContent.jsx';
import DynamicTreeDsgn from './components/designer/DynamicTree.jsx';
import CallCenterHomeDsgn from './components/designer/CallCenterHome.jsx';
import FastGridDsng from './components/designer/FastGrid.jsx';
import ForEachDsgn from './components/designer/ForEach.jsx';
import HSMDsgn from './components/designer/HSM.jsx';
//import HorizontalStackDsgn from './components/designer/HorizontalStack.jsx';
import HtmlTableDsgn from './components/designer/HtmlTable.jsx';
import ImageDsgn from './components/designer/Image.jsx';
import IconPopupMenuDsgn from './components/designer/IconPopupMenu.jsx';
import IntervalDsgn from './components/designer/Interval.jsx';
//import LayoutTile from './designer/LayoutTile.jsx';
//import MicAnalyzer from './designer/MicAnalyzer.jsx';
import NavigationDrawerDsgn from './components/designer/NavigationDrawer.jsx';
import MultiSelectListDsgn from './components/designer/MultiSelectList.jsx';
import NotificationDsgn from "./components/designer/Notification.jsx";
import PopupMenuButtonDsgn from './components/designer/PopupMenuButton.jsx';
import ProgressBarDsgn from './components/designer/ProgressBar.jsx';
import ProgressCircleDsgn from './components/designer/ProgressCircle.jsx';
//import RealTimeGrid from './designer/RealTimeGrid.jsx';
import ReplaceContent from './components/designer/actions/ReplaceContent.jsx';
import RecaptchaDsgn from './components/designer/Recaptcha.jsx';
import RoosterEditorDsgn from "./components/designer/RoosterEditor.jsx";
import SearchDsgn from './components/designer/Search.jsx';
import SelectListDsgn from './components/designer/SelectList.jsx';
import ServerEventListenerDsgn from './components/designer/ServerEventListener.jsx';
import SplitPanesDsgn from './components/designer/SplitPanes.jsx';
import SoftPhoneDsgn from './components/designer/SoftPhone.jsx';
import TabDsgn from './components/designer/actions/Tab.jsx';
import TextDsgn from './components/designer/Text.jsx';
import MarkdownDsgn from './components/designer/Markdown.jsx';
import TimelineDsgn from './components/designer/Timeline.jsx';
import TimeoutDsgn from "./components/designer/Timeout.jsx";
import UserActionDsgn from './components/designer/actions/UserAction.jsx';
import UserControlDsgn from './components/designer/UserControl.jsx';
import VerticalStackDsgn from './components/designer/VerticalStack.jsx';
import WatcherDsgn from './components/designer/Watcher.jsx';
import WizardDsgn from './components/designer/Wizard.jsx';

// Designer proprety grid form controls
import schemaFormDsgn from './components/designer/form/SchemaForm.jsx';
import formInputDsgn from './components/designer/form/input.jsx';
import formInputMultilineDsgn from './components/designer/form/inputmultiline.jsx';
import formNumberDsgn from './components/designer/form/number.jsx';
import formCheckboxDsgn from './components/designer/form/checkbox.jsx';
import formSelectDsgn from './components/designer/form/select.jsx';
import formAnyOfDsgn from './components/designer/form/anyof.jsx';
import formArrayDsgn from './components/designer/form/array.jsx';
import formTabarrayDsgn from './components/designer/form/tabarray.jsx';
import formSectionDsgn from './components/designer/form/section.jsx';
import formLookupListDsgn from './components/designer/form/lookupList.jsx';
import formHelpDsgn from './components/designer/form/help.jsx';
import formParagraphDsgn from './components/designer/form/paragraph.jsx';
import formRadiosDsgn from './components/designer/form/radios.jsx';
import formControlsWithLabelDsgn from './components/designer/form/controlsWithLabel.jsx';

// Schema form components
utils.dynamicComponents['sform-card-layout'] = layoutCard;
utils.dynamicComponents['sform-table-layout'] = tableLayout;
utils.dynamicComponents['sform-fieldset'] = formFieldset;
utils.dynamicComponents['sform-array'] = formArray;
utils.dynamicComponents['sform-anyof'] = formAnyOf;
utils.dynamicComponents['sform-tabarray'] = formTabArray;
utils.dynamicComponents['sform-text'] = formText;
utils.dynamicComponents['sform-email'] = formEmail;
utils.dynamicComponents['sform-phonenumber'] = formPhoneNumber;
utils.dynamicComponents['sform-string'] = formText;
utils.dynamicComponents['sform-password'] = formPassword;
utils.dynamicComponents['sform-tabs'] = formTabs;
utils.dynamicComponents['sform-lookuplist'] = formLookupList;
utils.dynamicComponents['sform-select'] = formSelect;
utils.dynamicComponents['sform-checkbox'] = formCheckbox;
utils.dynamicComponents['sform-checkboxes-array'] = formCheckboxes;
utils.dynamicComponents['sform-number'] = formNumber;
utils.dynamicComponents['sform-basiciconpicker'] = formBasicIconPicker;
utils.dynamicComponents['sform-iconpicker'] = formIconPicker;
utils.dynamicComponents['sform-paragraph'] = formParagraph;
utils.dynamicComponents['sform-help'] = formHelp;
utils.dynamicComponents['sform-textarea'] = formTextarea;
utils.dynamicComponents['sform-textareawithheaderbar'] = formTextareaWithHeaderBar;
utils.dynamicComponents['sform-mediaselector'] = formMediaSelector;
utils.dynamicComponents['sform-inputwithheaderbar'] = formInputWithHeaderBar;
utils.dynamicComponents['sform-switch'] = formSwitch;
utils.dynamicComponents['sform-radios'] = formRadios;
utils.dynamicComponents['sform-section'] = formSection;
utils.dynamicComponents['sform-localesection'] = formLocaleSection;
utils.dynamicComponents['sform-actions'] = formActions;
utils.dynamicComponents['sform-button'] = formButton;
utils.dynamicComponents['sform-tags'] = formTags;
utils.dynamicComponents['sform-texteditor'] = formTextEditor;
utils.dynamicComponents['sform-htmleditor'] = formHtmlEditor;
utils.dynamicComponents['sform-markdowneditor'] = formMarkdownEditor;
utils.dynamicComponents['sform-referenceddocumentschema'] = formReferencedDocumentSchema;
utils.dynamicComponents['sform-filepicker'] = formFilePicker;
utils.dynamicComponents['sform-filepickerwithheaderbar'] = formFilePickerWithHeaderBar;
utils.dynamicComponents['sform-dropdownmultiselect'] = formDropdownMultiSelect;
utils.dynamicComponents['sform-ttsvoicepicker'] = formTTSVoicePicker;
utils.dynamicComponents['sform-controls-with-label'] = formControlsWithLabel;
utils.dynamicComponents['sform-date-time'] = formDateTime;
utils.dynamicComponents['sform-date'] = formDate;
utils.dynamicComponents['sform-datepicker'] = formDatePicker;
utils.dynamicComponents['sform-time'] = formTime;
utils.dynamicComponents['sform-daterangepicker'] = formDateRangePicker;
utils.dynamicComponents['sform-singledatepicker'] = formSingleDatePicker;
utils.dynamicComponents['sform-conditional'] = formConditional;

// Property grid form components
utils.dynamicComponents['form-input'] = formInput;
utils.dynamicComponents['form-number'] = formNumberPropGrid;
utils.dynamicComponents['form-boolean'] = formBoolean;
utils.dynamicComponents['form-array'] = formArrayPropGrid;
utils.dynamicComponents['form-anyof'] = formAnyOfPropGrid;
utils.dynamicComponents['form-select'] = formSelectPropGrid;
utils.dynamicComponents['form-text-editor'] = formTextEditorPropGrid;
utils.dynamicComponents['string-lookup-list'] = LookupList;
utils.dynamicComponents['nullable-type'] = nullableType;
utils.dynamicComponents['referenced-document-schema'] = ReferencedDocumentSchema;
utils.dynamicComponents['hsm-statement-schema'] = HsmStatementSchema;

// Standard components
utils.dynamicComponents['default-unknown'] = Dummy;
utils.dynamicComponents['accordion'] = Accordion;
utils.dynamicComponents['api-tester'] = APITester;
utils.dynamicComponents['acd-direct-button'] = ACDDirectButton;
utils.dynamicComponents['advanced-history'] = AdvancedHistory;
utils.dynamicComponents['advanced-reports'] = AdvancedReports;
utils.dynamicComponents['apex-general-chart'] = ApexGeneralChart;
utils.dynamicComponents['apple-button'] = AppleButton;
utils.dynamicComponents['audio-player'] = AudioPlayer;
utils.dynamicComponents['auto-complete'] = AutoComplete;
utils.dynamicComponents['basic-avatar'] = Avatar;
utils.dynamicComponents['badge-handler'] = BadgeHandler;
utils.dynamicComponents['bar-chart'] = BarChart;
utils.dynamicComponents['basic-button'] = BasicButton;
utils.dynamicComponents['basic-file-upload'] = BasicFileUpload;
utils.dynamicComponents['call-center-home'] = CallCenterHome;
utils.dynamicComponents['basic-form'] = BasicForm;
utils.dynamicComponents['basic-grid'] = BasicGrid;
utils.dynamicComponents['basic-input'] = BasicInput;
utils.dynamicComponents['basic-link'] = BasicLink;
utils.dynamicComponents['basic-popup-menu'] = BasicPopupMenu;
utils.dynamicComponents['basic-tab'] = BasicTab;
utils.dynamicComponents['basic-switch'] = BasicToggle; // old BasicSwitch is virtually the same as BasicToggle, BasicToggle has slightly more features
utils.dynamicComponents['basic-toggle'] = BasicToggle;
utils.dynamicComponents['basic-tree'] = BasicTree;
utils.dynamicComponents['checkbox'] = Checkbox;
utils.dynamicComponents['broadcast-listener'] = BroadcastListener;
utils.dynamicComponents['card-list'] = CardList;
utils.dynamicComponents['calendar-picker'] = CalendarPicker;
utils.dynamicComponents['calendar-range-picker'] = CalendarRangePicker;
utils.dynamicComponents['circle-chart'] = CircleChart;
utils.dynamicComponents['combo-box'] = ComboBox;
utils.dynamicComponents['control-designer'] = ControlDesigner;
utils.dynamicComponents['control-designer-v3'] = ControlDesignerV3;
utils.dynamicComponents['conversation-view'] = ConversationView;
utils.dynamicComponents['css-style'] = CssStyle;
utils.dynamicComponents['dash'] = Dash;
utils.dynamicComponents['debug-hsm-log'] = DebugHsmLog;
utils.dynamicComponents['desktop-notify'] = DesktopNotify;
utils.dynamicComponents['dock-layout'] = DockLayout;
utils.dynamicComponents['document-bootstrap'] = DocumentBootstrap;
utils.dynamicComponents['dropdown-filelist'] = DropdownFileList;
utils.dynamicComponents['dropdown-list'] = DropdownList;
utils.dynamicComponents['dropdown-multi-select'] = DropdownMultiSelect;
utils.dynamicComponents['dynamic-control-container'] = DynamicControlContainer;
utils.dynamicComponents['dynamic-menu-list'] = DynamicMenuList;
utils.dynamicComponents['dynamic-tab'] = DynamicTab;
utils.dynamicComponents['dynamic-tab-content'] = DynamicTabContent;
utils.dynamicComponents['dynamic-tree'] = DynamicTree;
utils.dynamicComponents['fast-grid'] = FastGrid;
utils.dynamicComponents['file-diff'] = FileDiffv2;
utils.dynamicComponents['flow-v2'] = FlowV2;
utils.dynamicComponents['flow-chart'] = FlowChart;
utils.dynamicComponents['for-each'] = ForEach;
utils.dynamicComponents['google-button-v2'] = GoogleButton_v2;
utils.dynamicComponents['hsm-new'] = HsmNew;
utils.dynamicComponents['hsm-container'] = HSMContainer;
utils.dynamicComponents['hsm-state-new'] = HSMState;
utils.dynamicComponents['html-table'] = HtmlTable;
utils.dynamicComponents['html-component'] = Html;
utils.dynamicComponents['basic-icon'] = Icon;
utils.dynamicComponents['icon-popup-menu'] = IconPopupMenu;
utils.dynamicComponents['icon-stack'] = IconStack;
utils.dynamicComponents['iframe-component'] = IFrame;
utils.dynamicComponents['sandboxed-app'] = SandboxedApp;
utils.dynamicComponents['native-vue-host'] = NativeVueHost;
registerNativePages();
utils.dynamicComponents['image-control'] = Image;
utils.dynamicComponents['cc-progress-bar'] = ProgressBar;
utils.dynamicComponents['cc-progress-circle'] = ProgressCircle;
utils.dynamicComponents['infinite-grid'] = InfiniteGrid;
utils.dynamicComponents['infinite-conversation-view'] = InfiniteConversationView;
utils.dynamicComponents['interval'] = Interval;
utils.dynamicComponents['javascript'] = Javascript;
utils.dynamicComponents['line-chart'] = LineChart;
utils.dynamicComponents['media-approval'] = MediaApproval;
utils.dynamicComponents['multiselectlist'] = MultiSelectList;
utils.dynamicComponents['navigation-drawer'] = NavigationDrawer;
utils.dynamicComponents['notification'] = Notification;
utils.dynamicComponents['popup-menu-button'] = PopupMenuButton;
utils.dynamicComponents['dynamic-user-control-hsm'] = UserControlHSM;
utils.dynamicComponents['dynamic-user-control'] = UserControl;
utils.dynamicComponents['sound-player'] = SoundPlayer;
utils.dynamicComponents['split-panes'] = SplitPanes;
utils.dynamicComponents['basic-text'] = Text;
utils.dynamicComponents['markdown'] = Markdown;
utils.dynamicComponents['text-editor'] = TextEditor;
utils.dynamicComponents['cc-timeline'] = Timeline;
utils.dynamicComponents['timeout'] = Timeout;
utils.dynamicComponents['tree-view'] = TreeView;
utils.dynamicComponents['tree-view-dsgn'] = TreeViewDsgn;
utils.dynamicComponents['real-time-grid'] = RealTimeGridAg;
utils.dynamicComponents['realtime-widget-listener'] = RealTimeWidgetListener;
utils.dynamicComponents['rooster-editor'] = RoosterEditor;
utils.dynamicComponents['rt-event-handler'] = RTEventHandler;
utils.dynamicComponents['saml-button'] = SAMLButton;
utils.dynamicComponents['select-list'] = SelectList;
utils.dynamicComponents['search'] = Search;
utils.dynamicComponents['search-query-builder'] = SearchQueryBuilder;
utils.dynamicComponents['server-event-listener'] = ServerEventListener;
utils.dynamicComponents['soft-phone'] = SoftPhone;
utils.dynamicComponents['stack-vertical'] = VerticalStack;
utils.dynamicComponents['basic-watcher'] = Watcher;
utils.dynamicComponents['web-rtc-phone'] = WebRtcPhone;
utils.dynamicComponents['user-action-listener'] = UserActionListener;
utils.dynamicComponents['cc-wizard'] = Wizard;
utils.dynamicComponents['cc-wizard-dsgn'] = WizardDsgn;
utils.dynamicComponents['wizard-button'] = WizardButton;
utils.dynamicComponents['youtube-video'] = YouTubeVideo;

// Form Designer versions of standard components
utils.dynamicComponents['default-unknown-dsgn'] = DefaultUnknownDsgn;

utils.dynamicComponents['accordion-dsgn'] = AccordionDsgn;
utils.dynamicComponents['carecenter-menu-dsgn'] = CareCenterMenuDsgn;
utils.dynamicComponents['carecenter-popupmenu-dsgn'] = CareCenterPopupMenuDsgn;
utils.dynamicComponents['combo-box-dsgn'] = ComboBoxDsgn;
utils.dynamicComponents['dash-dsgn'] = DashDsgn;
utils.dynamicComponents['apex-general-chart-dsgn'] = ApexGeneralChartDsgn;
utils.dynamicComponents['audio-player-dsgn'] = AudioPlayerDsgn;
utils.dynamicComponents['basic-avatar-dsgn'] = AvatarDsgn;
utils.dynamicComponents['basic-button-dsgn'] = BasicButtonDsgn;
utils.dynamicComponents['broadcast-listener-dsgn'] = BroadcastListenerDsgn;
utils.dynamicComponents['basic-popup-menu-dsgn'] = BasicPopupMenuDsgn;
utils.dynamicComponents['basic-switch-dsgn'] = BasicToggleDsgn;
utils.dynamicComponents['call-center-home-dsgn'] = CallCenterHomeDsgn;
utils.dynamicComponents['basic-toggle-dsgn'] = BasicToggleDsgn;
utils.dynamicComponents['basic-tab-dsgn'] = BasicTabDsgn;
utils.dynamicComponents['basic-tree-dsgn'] = BasicTreeDsgn;
utils.dynamicComponents['basic-icon-dsgn'] = BasicIconDsgn;
utils.dynamicComponents['calendar-picker-dsgn'] = CalendarPickerDsgn;
utils.dynamicComponents['card-list-dsgn'] = CardListDsgn;
utils.dynamicComponents['checkbox-dsgn'] = CheckboxDsgn;
utils.dynamicComponents['icon-popup-menu-dsgn'] = IconPopupMenuDsgn;
utils.dynamicComponents['image-control-dsgn'] = ImageDsgn;
utils.dynamicComponents['interval-dsgn'] = IntervalDsgn;
utils.dynamicComponents['wizard-button-dsgn'] = BasicButtonDsgn;
utils.dynamicComponents['basic-grid-dsgn'] = BasicGridDsgn;
utils.dynamicComponents['basic-input-dsgn'] = BasicInputDsgn;
utils.dynamicComponents['background-service-dsgn'] = BackgroundServiceDsgn;
utils.dynamicComponents['display-basic-modal-dsgn'] = DisplayBasicModal;
utils.dynamicComponents['notification-dsgn'] = NotificationDsgn;
utils.dynamicComponents['popup-menu-button-dsgn'] = PopupMenuButtonDsgn;
utils.dynamicComponents['cc-progress-bar-dsgn'] = ProgressBarDsgn;
utils.dynamicComponents['cc-progress-circle-dsgn'] = ProgressCircleDsgn;
utils.dynamicComponents['rooster-editor-dsgn'] = RoosterEditorDsgn;
utils.dynamicComponents['recaptcha-dsgn'] = RecaptchaDsgn;
utils.dynamicComponents['search-dsgn'] = SearchDsgn;
utils.dynamicComponents['server-event-listener-dsgn'] = ServerEventListenerDsgn;
utils.dynamicComponents['split-panes-dsgn'] = SplitPanesDsgn;
utils.dynamicComponents['soft-phone-dsgn'] = SoftPhoneDsgn;
utils.dynamicComponents['select-list-dsgn'] = SelectListDsgn;
utils.dynamicComponents['dropdown-list-dsgn'] = DropdownListDsgn;
utils.dynamicComponents['multiselectlist-dsgn'] = MultiSelectListDsgn;
utils.dynamicComponents['html-table-dsgn'] = HtmlTableDsgn;
utils.dynamicComponents['stack-vertical-dsgn'] = VerticalStackDsgn;
utils.dynamicComponents['basic-text-dsgn'] = TextDsgn;
utils.dynamicComponents['markdown-dsgn'] = MarkdownDsgn;
utils.dynamicComponents['cc-timeline-dsgn'] = TimelineDsgn;
utils.dynamicComponents['timeout-dsgn'] = TimeoutDsgn;
utils.dynamicComponents['tab-action-dsgn'] = TabDsgn;
utils.dynamicComponents['dynamic-user-action-dsgn'] = UserActionDsgn;
utils.dynamicComponents['hsm-new-dsgn'] = HSMDsgn;
utils.dynamicComponents['replace-content-action-dsgn'] = ReplaceContent;
utils.dynamicComponents['basic-link-dsgn'] = BasicLinkDsgn;
utils.dynamicComponents['basic-form-dsgn'] = BasicFormDsgn;
utils.dynamicComponents['dynamic-user-control-dsgn'] = UserControlDsgn;
utils.dynamicComponents['document-bootstrap-dsgn'] = DocumentBootstrapDsgn;
utils.dynamicComponents['dropdown-multi-select-dsgn'] = DropdownMultiSelectDsgn;
utils.dynamicComponents['dynamic-control-container-dsgn'] = DynamicControlContainerDsgn;
utils.dynamicComponents['dynamic-menu-list-dsgn'] = DynamicMenuListDsgn;
utils.dynamicComponents['dynamic-tab-dsgn'] = DynamicTabDsgn;
utils.dynamicComponents['dynamic-tab-content-dsgn'] = DynamicTabContentDsgn;
utils.dynamicComponents['navigation-drawer-dsgn'] = NavigationDrawerDsgn;
utils.dynamicComponents['dynamic-tree-dsgn'] = DynamicTreeDsgn;
utils.dynamicComponents['for-each-dsgn'] = ForEachDsgn;
utils.dynamicComponents['fast-grid-dsgn'] = FastGridDsng;
utils.dynamicComponents['basic-watcher-dsgn'] = WatcherDsgn;

// something
utils.dynamicComponents['schema-form-dsgn'] = schemaFormDsgn;
utils.dynamicComponents['form-input-dsgn'] = formInputDsgn;
utils.dynamicComponents['form-input-multiline-dsgn'] = formInputMultilineDsgn;
utils.dynamicComponents['form-select-dsgn'] = formSelectDsgn;
utils.dynamicComponents['form-anyof-dsgn'] = formAnyOfDsgn;
utils.dynamicComponents['form-array-dsgn'] = formArrayDsgn;
utils.dynamicComponents['form-tabarray-dsgn'] = formTabarrayDsgn;
utils.dynamicComponents['form-checkbox-dsgn'] = formCheckboxDsgn;
utils.dynamicComponents['form-number-dsgn'] = formNumberDsgn;
utils.dynamicComponents['form-section-dsgn'] = formSectionDsgn;
utils.dynamicComponents['form-paragraph-dsgn'] = formParagraphDsgn;
utils.dynamicComponents['form-radios-dsgn'] = formRadiosDsgn;
utils.dynamicComponents['string-lookup-list-dsgn'] = formLookupListDsgn;
utils.dynamicComponents['form-help-dsgn'] = formHelpDsgn;
utils.dynamicComponents['form-controls-with-label-dsgn'] = formControlsWithLabelDsgn;

//export default Vue.component("start-application", {
export default defineComponent({
    name: 'StartApplication',
    emits: ['start-application-created'],
    components: {
        TranslationContainer,
        BasicButton,
        Dummy,
        Text,
        VerticalStack,
    },
    data: () => ({
        _uid: utils._uid_counter++,
        _isroot: true,
        rootid: "",
        loading: true,
        access_token: null,
        refresh_token: null,
        control: null,
        currentPath: '',
        CustomerID: null,
        date_value: {
            value: null,
        },
        global_vars: {
            api_busy_indicator: false,
            debug_reveal: false,
            Theme: theme.getActiveTheme(),
        },
        service_vars: {
            tokenVars: {},
        },
        _children: [],

        PrivateVariables: {
            AccessToken: { Value: null },
            RefreshToken: { Value: null },
            ExpiresIn: { Value: null },
            ExpiresAbsoluteTime: { Value: null },
            UserSecurityContextID: { Value: null },
            UserID: { Value: null },
            CustomerSecurityContextID: { Value: null },
            CustomerTextToSpeechVoice: { Value: null },
            CustomerAbbreviation: { Value: null },
            CustomerID: { Value: null },
            CustomerName: { Value: null },
            CustomerTimezone: { Value: null },
            CustomerRegionCode: { Value: null },
            CustomerPhoneNumberFormat: { Value: null },
            CustomerDefaultPromptLanguage: { Value: null },
            E911Compliance: { Value: null },
            CustomerRoles: { Value: null },
            PermissionGroupID: { Value: null },
            BandID: { Value: null },
            ProviderType: { Value: null },
            UserName: { Value: null },
            Email: { Value: null},
            BandSwitchingEnabled: { Value: null }
        },
    }),
    created() {
        token.PrivateVariables = this.PrivateVariables;
        // Attempt to initialize the private variables from sessionStorage if found
        if (sessionStorage)
            for (let key in this.PrivateVariables) {
                if (typeof this.PrivateVariables[key] === 'object') {
                    const value = sessionStorage.getItem(key);
                    if (value !== undefined)
                        this.PrivateVariables[key].Value = value;
                }
            }

        window.addEventListener("keydown", (e) => {
            if (e.key == "Control" || e.key == "ControlLeft" || e.key == "ControlRight ") {
                this.global_vars.debug_reveal = true;
            }
        });
        window.addEventListener("keyup", (e) => {
            if (e.key == "Control" || e.key == "ControlLeft" || e.key == "ControlRight ") {
                this.global_vars.debug_reveal = false;
            }
        });
        window.addEventListener("event-bus-listener", (e) => {
            if (Array.isArray(e.detail.args))
                EventBus.$emit(e.detail.name, ...e.detail.args);
            else
                EventBus.$emit(e.detail.name, e.detail.args);
        });

        this.rootid = utils.generateUUID();

        // The query prop already carries SignOut=true, so QueryString() still sees it for this
        // page load. Consume it here so it does not follow the user around after signing in.
        utils.consumeSsoAutoLoginMarker();

        EventBus.$on("Logout", this.performLogout);
        EventBus.$on("SelectedCustomerChanged", this.performCustomerChange);

        this.date_value.value = new Date();
        careHelpfulFunctions.date_value = this.date_value;
        utils.global_variables = this.global_vars;
        utils.service_variables = this.service_vars;

        this.interval = setInterval(() => {
            this.date_value.value = new Date();
        }, 1000);

        this.$emit("start-application-created");

        this.getControl();
    },
    unmounted() {
        EventBus.$off("Logout", this.performLogout);
        EventBus.$off("SelectedCustomerChanged", this.performCustomerChange);
    },
    mounted() {
        window.addEventListener('hashchange', this.handleHashChange);
    },
    beforeUnmount() {
        window.removeEventListener('hashchange', this.handleHashChange);
    },
    props: {
        route: "",
        query: "",
        path: "",
    },
    computed: {
        ...computed,
    },
    methods: {
        ...methods,
        ...filters,
        finishRenderHandler(component) {
            if (component && component.$.uid !== this.$.uid)
                this._children.push(component);
        },
        performLogout() {
            utils.suppressSsoAutoLogin();
            this.performCustomerChange();
        },
        performCustomerChange() {
            this.rootid = utils.generateUUID();

            //clear any global variables as needed.
            utils.logout();
        },
        getControl: async function () {
            // Load the master user control to get everything running
            if (!this.control) {
                if (this.route) {
                    let route = this.route.substr(1);
                    if (route.includes('!')) route = route.replace('!', '');
                    if (route.startsWith("/")) route = route.substr(1);
                    if (route.includes("?")) route = route.substring(0, route.indexOf("?"));
                    if (route.startsWith("Control")) route = route.replace("Control", "");

                    if (!route)
                        route = 'v1/Vue/CallCenterPortal';
                    else if (route.startsWith('#'))
                        route = 'v1/Vue/CallCenterPortal';

                    this.control = await api.get("Document/UserControl/" + route);
                }
                else
                    this.control = await api.get("Document/UserControl/v1/Vue/CallCenterPortal");
                    //this.control = await api.get("Document/UserControl/v1/Vue/PortalVue3");
            }
        },
        pushRoute(path) {
            const normalizedPath = path.startsWith('/') ? path : `/${path}`;
            window.location.hash = normalizedPath;
        },
        go(n) {
            window.history.go(n);
        },
        handleHashChange() {
            this.currentPath = window.location.hash.slice(1) || '/';
        },
    },
    render() {
        if (!this.control) return <div><TranslationContainer context={this} value={"Loading..."}/>;</div>;

        let DynamicControl = utils.getDynamicComponent(h, this.control);
        if (!DynamicControl) return <div>Control type of {this.control.ControlType} is unknown</div>;

        return (
            <DynamicControl
                key={this.rootid}
                ref="mainscreen"
                root={this}
                name={this.control.ControlData.Name}
                parentType="App"
                controlData={this.control.ControlData}
                accessPermission={this.control.AccessPermission}
                type={this.control.ControlType}
                cacheControl={this.control.CacheControl}
                controlEvents={this.control.Events}
                asbase={true}
                onFinishedRender={(reference) => this.finishRenderHandler(reference)}
            ></DynamicControl>
        );
    },
});
